import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-12">
      <div className="max-w-6xl mx-auto px-6" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-12 md:gap-24" data-id="element-14">
          <FadeIn data-id="element-15">
            <h3 className="text-2xl font-serif font-bold text-olive mb-8 flex items-center gap-3" data-id="element-16">
              <CheckCircle2 className="w-8 h-8" data-id="element-17" />
              Es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-18">
              {['te frustra que tu pelo cambie según el día', 'compras productos porque estás desesperada por una solución', 'quieres una guía clara, por tipo, sin tecnicismos', 'necesitas resultados con una rutina corta'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-brown-800" data-id="element-19">
                  <div className="w-2 h-2 rounded-full bg-olive mt-2.5 shrink-0" data-id="element-20" />
                  <span data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-22">
            <h3 className="text-2xl font-serif font-bold text-rose-muted mb-8 flex items-center gap-3" data-id="element-23">
              <XCircle className="w-8 h-8" data-id="element-24" />
              No es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-25">
              {['buscas una rutina de 60 minutos', "quieres 'técnicas de salón' como requisito", 'no quieres seguir pasos simples'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-brown-800/70" data-id="element-26">
                  <div className="w-2 h-2 rounded-full bg-rose-muted mt-2.5 shrink-0" data-id="element-27" />
                  <span data-id="element-28">{item}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}